export const HOTELS_HEADER = "Hotels";
export const STAYS_HEADER = "Stays";

export const UPDATE_CALENDAR_TEXT = "Choose Dates";
